import {
  SET_CLIENT_TICKET_DATA,
  RESET_CLIENT_TICKET,
} from "../../appRedux/actions/ClientTicket";

const INITIAL_STATE = {
  // Project & service
  project_id: "",
  sow_sub_types: "",
  sow_name: "",

  // Address
  is_international: false,
  raw_address: "",
  pin_code: "",
  city: "",
  district: "",
  state: "",
  country: "India",
  location: "",

  // Contact
  customer_name: "",
  customer_email: "",
  phone: "",
  prefix: "+91",

  // Optional
  client_ticket_identifier: "",
  case_id: "",
};

export default function ClientTicket(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_CLIENT_TICKET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case RESET_CLIENT_TICKET:
      return { ...INITIAL_STATE };
    default:
      return state;
  }
}
